<div
  class="wrapper--spacing-vertical"
  *ngIf="
    (selectedViewMode$ | async) === viewModes.Table && (isDetailedModeSelected$ | async) === false
  "
>
  <app-data-view-table-simple></app-data-view-table-simple>
</div>

<div
  class="wrapper--spacing-vertical"
  *ngIf="
    (selectedViewMode$ | async) === viewModes.Chart && (isDetailedModeSelected$ | async) === false
  "
>
  <app-data-view-graph-simple></app-data-view-graph-simple>
</div>

<div
  *ngIf="
    (selectedViewMode$ | async) === viewModes.Table && (isDetailedModeSelected$ | async) === true
  "
>
  <app-data-view-table-detailed></app-data-view-table-detailed>
</div>

<div
  *ngIf="
    (selectedViewMode$ | async) === viewModes.Chart && (isDetailedModeSelected$ | async) === true
  "
>
  <app-data-view-graph-detailed></app-data-view-graph-detailed>
</div>
